import { CardDesignTokens } from "@primeuix/themes/types/card";
import { primitiveLayoutTokens } from "src/assets/layout/styles/tokens/primitive";

export const card: CardDesignTokens = {
    root: {
        borderRadius: primitiveLayoutTokens.borderRadius,
    },
    body: {
        padding: "0.5rem 0",
    },
    extend: {
        highlight: {
            border: "1px solid #0c77ff",
            boxShadow: "0px 3px 6px #0c77ff1f",
            backgroundColor: "#f5faff",
        },
    },
    css: ({ dt }) => {
        /**
         * Base Overrides for p-card
         */
        const base = `
            .p-card .header {
                font-family: var(--p-azara-fonts-font-family-sans);
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 1rem;
                border-radius: 4px 4px 0 0;
                transition: all 200ms ease-in-out;
            }

            .p-card:hover .p-card-header .header {
                background-color: color-mix(in srgb, ${dt("card.highlight.background.color")} 70%, transparent);
            }

            .p-card:hover .p-card-header .icon-link {
                display: block;
            }
        `;

        /**
         * Highlight Card Styles
         * NOTE - BS - .icon-link is associated with an icon in the card header
         */
        const highlight = `
            .p-card__highlight {
                border: ${dt("card.highlight.border")};
                box-shadow: ${dt("card.highlight.box.shadow")};
                background: ${dt("card.highlight.background.color")} 0% 0% no-repeat padding-box;

                .header {
                    background-color: ${dt("card.highlight.background.color")};
                    color: var(--p-azara-blue-850);

                    .icon-link {
                        display: block;
                    }
                }
            }

            .icon-link {
                display: none;
                font-size: var(--p-azara-fonts-font-size-xm);
                font-weight: 700;
                color: var(--p-azara-blue-650);
            }
        `;

        return base + highlight;
    },
};
